module.exports = __webpack_public_path__ + "static/media/trisbee.76357809.jpg";